const coinDiscountName = /^(?:(?:used|použité)\s+)?(?:(?:veroc|v)\s+)?coins?$/i

/** Backend promotion names from older deployments still use the programme's former name. */
export function rewardDiscountLabel(description: string | null | undefined, fallback: string, coinsLabel: string): string {
  const label = description?.trim()
  if (label && coinDiscountName.test(label))
    return coinsLabel
  return label?.replace(/\b(?:veroc|v)\s+coins?\b/gi, coinsLabel) || fallback
}

/** Cart prices precede checkout's Coins opt-in, even when the saved order still has it applied. */
export function cartOrderBeforeCoins<T extends {
  subTotal: number
  total: number
  discounts?: readonly { description?: string | null, amount: number }[] | null
}>(order: T): T {
  let coinsDiscount = 0
  const discounts = order.discounts?.filter((discount) => {
    if (!coinDiscountName.test(discount.description?.trim() ?? ''))
      return true
    coinsDiscount += discount.amount
    return false
  })
  if (discounts?.length === order.discounts?.length)
    return order
  // The backend applies Coins to goods after other promotions, never to shipping.
  return { ...order, discounts, subTotal: order.subTotal - coinsDiscount, total: order.total - coinsDiscount }
}

/** Product rows retain their own selling price; order discounts have a separate totals row. */
export function orderLineDisplayPrice(line: { linePrice: number, discountedLinePrice?: number | null }): number {
  return line.discountedLinePrice ?? line.linePrice
}

/** Only these backend Stripe payment types qualify for the card-payment reward. */
export function rewardPaymentEligible(stripeType?: string | null): boolean {
  return ['card', 'apple_pay', 'google_pay'].includes(stripeType ?? '')
}

/** A preview only. The mutation response is always authoritative, including rounding. */
export function rewardRedemptionPreview(quote: { available: number, maxCoins: number }, programme: { currencyCode: string, redeemRate?: number | null } | null | undefined, currency: string): { coins: number, discount: number } | null {
  if (!programme || programme.currencyCode !== currency || !programme.redeemRate || programme.redeemRate <= 0)
    return null
  const step = currency === 'CZK' ? 100 : 1
  const discount = Math.floor(Math.min(quote.available, quote.maxCoins) * 100 / (programme.redeemRate * step) + 1e-9) * step
  return { coins: Math.max(0, Math.ceil(discount * programme.redeemRate / 100 - 1e-9)), discount }
}
